module.exports = [
	{
		"title": "base64",
		"path": "/en/tools/base64.html"
	},
	{
		"title": "cookie",
		"path": "/en/tools/cookie.html"
	},
	{
		"title": "date format",
		"path": "/en/tools/date.html"
	},
	{
		"title": "debounce",
		"path": "/en/tools/debounce-throttle.html"
	},
	{
		"title": "md5",
		"path": "/en/tools/md5.html"
	},
	{
		"title": "number format",
		"path": "/en/tools/number.html"
	},
	{
		"title": "url querystring",
		"path": "/en/tools/querystring.html"
	},
	{
		"title": "trim string",
		"path": "/en/tools/string.html"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/tool-routes-en.json
// module id = 301
// module chunks = 483